const SHORT_TOOLTIP_MAX_CHARS = 80;
const SHORT_TOOLTIP_MAX_WIDTH = 300;
const LONG_TOOLTIP_MAX_WIDTH = 380;

export function getAccordionHeaderTooltipMaxWidth(tooltip) {
  if (Array.isArray(tooltip)) {
    return LONG_TOOLTIP_MAX_WIDTH;
  }
  if (typeof tooltip === "string" && tooltip.length <= SHORT_TOOLTIP_MAX_CHARS) {
    return SHORT_TOOLTIP_MAX_WIDTH;
  }
  return LONG_TOOLTIP_MAX_WIDTH;
}
